export default function inputVal(func) {
  return function({ target }) {
    func(target?.value);
  };
}
